export const cropSentence = (sentence, wordLimit) => {
  const words = sentence.split(" ");
  return words.length > wordLimit
    ? words.slice(0, wordLimit).join(" ") + "..."
    : sentence;
};


